import { useEffect } from "react";

const ERP_MANIFEST = "/manifest.json";

// Gives the customer site its own PWA identity (id/scope/start_url) so a Home-Screen
// shortcut never resolves to the ERP app (which owns /manifest.json with start_url "/").
export const useSiteManifest = (slug, site) => {
  useEffect(() => {
    if (!slug) return undefined;
    const link = document.querySelector('link[rel="manifest"]');
    const prevHref = link?.getAttribute("href");
    link?.setAttribute("href", `/api/public/online/${slug}/manifest.webmanifest`);
    const added = [];
    const meta = (name, content) => { const m = document.createElement("meta"); m.name = name; m.content = content; document.head.appendChild(m); added.push(m); };
    meta("apple-mobile-web-app-capable", "yes");
    meta("apple-mobile-web-app-title", site?.brand?.name || "Order Online");
    const theme = document.querySelector('meta[name="theme-color"]');
    const prevTheme = theme?.getAttribute("content");
    if (site?.brand?.primary_color) theme?.setAttribute("content", site.brand.primary_color);
    if (site?.brand?.logo_url) { const l = document.createElement("link"); l.rel = "apple-touch-icon"; l.href = site.brand.logo_url; document.head.appendChild(l); added.push(l); }
    return () => {
      link?.setAttribute("href", prevHref || ERP_MANIFEST);
      if (prevTheme) theme?.setAttribute("content", prevTheme);
      added.forEach((n) => n.remove());
    };
  }, [slug, site?.brand?.name, site?.brand?.primary_color, site?.brand?.logo_url]);
};
